import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c02fd9f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vacancies__header" }
const _hoisted_2 = { class: "more__info_vacancies" }
const _hoisted_3 = { class: "vacancies__body" }
const _hoisted_4 = { class: "vacancie__name" }
const _hoisted_5 = {
  key: 0,
  class: "vacancie__category"
}
const _hoisted_6 = { class: "vacancie__category_text" }
const _hoisted_7 = { class: "vacancie__items" }
const _hoisted_8 = {
  key: 1,
  class: "vacancie__category"
}
const _hoisted_9 = { class: "vacancie__category_text" }
const _hoisted_10 = { class: "vacancie__items" }
const _hoisted_11 = {
  key: 2,
  class: "vacancie__category"
}
const _hoisted_12 = { class: "vacancie__category_text" }
const _hoisted_13 = { class: "vacancie__items" }
const _hoisted_14 = {
  key: 3,
  class: "vacancie__category"
}
const _hoisted_15 = { class: "vacancie__category_text" }
const _hoisted_16 = { class: "vacancie__items" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line__modal" }, null, -1))
const _hoisted_18 = {
  class: "form_vacancie",
  ref: "formVacan"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_close_modal_layout = _resolveComponent("close-modal-layout")!
  const _component_hr_links = _resolveComponent("hr-links")!
  const _component_form_vacancies = _resolveComponent("form-vacancies")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "modalTransition",
    duration: 600
  }, {
    default: _withCtx(() => [
      (_ctx.getModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal",
            onClick: _cache[2] || (_cache[2] = () => _ctx.setModal(false))
          }, [
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
              class: "vacancies__modal_content"
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_close_modal_layout, { setModal: _ctx.setModal }, null, 8, ["setModal"]),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", {
                    class: "click_vacan",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScrollVacan && _ctx.handleScrollVacan(...args)))
                  }, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.getStaticLanguage.applyVacancie), 1)
                  ]),
                  _createVNode(_component_hr_links, {
                    text: 'HR Linkedin',
                    active: true,
                    link: 'https://www.linkedin.com/in/michael-catcher-8b57521b0/'
                  }, null, 8, ["link"])
                ])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(this.getVacan?.name), 1),
                (this.getVacan?.responsibilities.length ? true : false)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.getStaticLanguage.responsibilities), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.getVacan?.responsibilities, (responsibilitie, ind) => {
                        return (_openBlock(), _createElementBlock("li", { key: ind }, [
                          _createElementVNode("p", _hoisted_7, _toDisplayString(responsibilitie), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (this.getVacan?.requirements.length ? true : false)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                      _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.getStaticLanguage.requirements), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.getVacan?.requirements, (requirements, ind) => {
                        return (_openBlock(), _createElementBlock("li", { key: ind }, [
                          _createElementVNode("p", _hoisted_10, _toDisplayString(requirements), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (this.getVacan?.advantages.length ? true : false)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                      _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.getStaticLanguage.advantages), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.getVacan?.advantages, (advantages, ind) => {
                        return (_openBlock(), _createElementBlock("li", { key: ind }, [
                          _createElementVNode("p", _hoisted_13, _toDisplayString(advantages), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (this.getVacan?.conditions.length ? true : false)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                      _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.getStaticLanguage.conditions), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.getVacan?.conditions, (conditions, ind) => {
                        return (_openBlock(), _createElementBlock("li", { key: ind }, [
                          _createElementVNode("p", _hoisted_16, _toDisplayString(conditions), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_form_vacancies, { count: 2 })
                ], 512)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}